import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../Component/Button/Button';
import Input from '../../Component/Input/Input';
import { Logo } from '../../constant/imagePath';
import { saveLoginUserData } from '../../store/auth/authSlice';
import classes from './Login.module.css';
import { FcGoogle } from 'react-icons/fc';
import { useTranslation } from 'react-i18next';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { IoChevronBackOutline } from 'react-icons/io5';
import { RiAccountCircleLine } from 'react-icons/ri';
import CustomPopover from '../../Component/CustomPopover';
import { useLoginMutation } from '../../store/apiSlice/apiSlice';
import { setDirection, setSelectLanguage } from '../../store/language/languageSlice';
import {
  setAllCompareList,
  setAllFavorite,
  setAllInquiryMessageAndRequest,
  setAllPropertyProjectsAndEvents,
  setAllSavedSearch
} from '../../store/notification/notificationSlice';

function Login() {
  const [openLanguages, setOpenLanguages] = useState(null);
  const { selectedLanguage, direction } = useSelector((state) => state?.languageReducer);
  const { i18n } = useTranslation('webCommon');
  const { t } = useTranslation('loginAndSignup');
  const d = (e) => t(`login.${e}`);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signinFn, { isLoading: signinLoading }] = useLoginMutation();
  const [formStates, setFormStates] = useState({
    email: '',
    password: ''
  });

  function handleFormStateUpdate(key, value) {
    setFormStates({ ...formStates, [key]: value });
  }
  const { languages } = useSelector((state) => state.commonReducer);
  const mapLang = languages && languages;

  async function onLogin() {
    const response = await signinFn(formStates);
    if (response?.data) {
      if (response?.data?.data?.user?.isActive == false) {
        navigate(`/verify-otp-signup?email=${response?.data?.data?.user?.email}&login=true`);
        return;
      }
      dispatch(saveLoginUserData(response?.data));
      if (response?.data?.data?.propertyProjectsAndEvents) {
        dispatch(setAllPropertyProjectsAndEvents(response?.data?.data?.propertyProjectsAndEvents));
      }
      if (response?.data?.data?.favorite) {
        dispatch(setAllFavorite(response?.data?.data?.favorite));
      }
      if (response?.data?.data?.savedSearches) {
        dispatch(setAllSavedSearch(response?.data?.data?.savedSearches));
      }
      if (response?.data?.data?.compareList) {
        dispatch(setAllCompareList(response?.data?.data?.compareList));
      }
      if (response?.data?.data?.inquiryMessageAndRequest) {
        dispatch(setAllInquiryMessageAndRequest(response?.data?.data?.inquiryMessageAndRequest));
      }
      if (response?.data?.data?.user?.role == 'company') {
        navigate('/company/dashboard');
      } else if (response?.data?.data?.user?.role == 'agent') {
        navigate('/agent/dashboard');
      } else {
        navigate('/account-settings');
      }
    }
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    dispatch(setSelectLanguage(lng));
    if (['ar', 'fa'].includes(lng)) {
      dispatch(setDirection('rtl'));
    } else {
      dispatch(setDirection('ltr'));
    }
  };


  return (
    <div>
      <div className={classes.bg}>
        <div className={classes.content}>
          <form
            className={classes.form}
            onSubmit={(e) => {
              e?.preventDefault();
              onLogin();
            }}>
            <div className={classes.backBtn} >
              <button className='btnWrapper'
              onClick={() => navigate(-1)}
              >

          
              <IoChevronBackOutline size={24} />
              </button>
            </div>
            <Row className={classes.formRow}>
              <div className={classes.Header}>
                <Col md={9} dir={direction}>
                  <div className={classes.logoDiv}>
                    <img 
                    alt='logo'
                    src={Logo} />
                  </div>
                  {/* <h4>
                      {d('role')}
                    </h4> */}
                </Col>

                <Col md={3}>
                  <CustomPopover
                    anchorEl={openLanguages}
                    setAnchorEl={setOpenLanguages}
                    Component={
                      <ul className={[classes?.languagesOptions, 'ltr'].join(' ')}>
                        {mapLang?.map((item, index) => {
                          return (
                            <button className='btnWrapper'
                            key={`${item?._id}-${index}`}
                            onClick={() => {
                              changeLanguage(item?.value);
                              setOpenLanguages(null);
                            }}
                            >

                          
                            <li
                              key={`${item?._id}-${index}`}
                              data-selected={selectedLanguage == item?.value}
                            >
                              <img 
                              alt={item?.label}
                              src={item?.flag} /> {item?.label}
                            </li>
                            </button>
                          );
                        })}
                      </ul>
                    }
                    className={classes.overlay}
                    TriggerComp={() => (
                      <li>
                        <Button
                          variant="transparent"
                          rightIcon={<HiOutlineChevronDown size={20} color="#000" />}
                          className={('t-t-c', classes.languageBtn)}>
                          <img
                          alt={mapLang?.find((item) => item?.value === selectedLanguage)?.label}
                            className={classes.flag}
                            src={mapLang?.find((item) => item?.value === selectedLanguage)?.flag}
                          />
                        </Button>
                      </li>
                    )}
                  />
                </Col>
              </div>

              <Col md={12}>
                <Button variant="" leftIcon={<FcGoogle size={20} />} className={classes.googleBtn}>
                  {d('continueWithGoogle')}
                </Button>
              </Col>
              <Col md={12}>
                <div className={classes.dividerContainer}>
                  <div className={classes.line}></div>
                  <span className={classes.textspan}>{d('or')}</span>
                  <div className={classes.line}></div>
                </div>
              </Col>

              <Col md={12}>
                <Input
                  label={d('email')}
                  value={formStates?.email}
                  setValue={(e) => handleFormStateUpdate('email', e)}
                  type={'email'}
                  placeholder={d('email')}
                  className={classes.input}
                />
              </Col>

              <Col md={12}>
                <Input
                  label={
                    <Col md={12} className={classes.forgotPassword}>
                      {d('password')}
                      <Link to={'/forgot-password'} className={`link ${classes.link}`}>
                        {d('forgotPassword')}
                      </Link>
                    </Col>
                  }
                  value={formStates?.password}
                  setValue={(e) => handleFormStateUpdate('password', e)}
                  type={'password'}
                  placeholder={d('password')}
                  className={classes.input}
                />
              </Col>

              <Col md={12} className={classes.btns}>
                <Button type={'submit'} variant="primary">
                  {signinLoading ? d('loading') : d('title')}
                </Button>
              </Col>
              <Col md={12} className={classes.textCenter}>
                <p className={classes.text}>
                  {d('dontHaveAnAccount')}{' '}
                  <Link to={'/signup'} className={`link ${classes.link}`}>
                    {d('signup')}
                  </Link>
                </p>
              </Col>
            </Row>
          </form>
          <Col md={12} className={classes.AgentLogin}>
            <RiAccountCircleLine color="#F28E1D" size={30} />
            <Link to={'/agent-company-login'} className={`link ${classes.link}`}>
              <p> {d('LoginAsBuyer')}</p>
            </Link>
          </Col>
        </div>
      </div>
    </div>
  );
}

export default Login;
